import ActionsChart from "./actions-chart.vue";

export default ActionsChart;



// WEBPACK FOOTER //
// ./src/components/_charts/actions/index.js